import { useState } from "react";
import { Link } from "react-router-dom";
import { Button as ExpanoButton, Label, ModalDelete } from "expano-components";
import { Button, Dashboard } from "components";
import useDelete from "hooks/useDelete";
import { channel_campaign_statuses } from "utils/select_options/channel_campaign_statuses_options";
import { getChannelCampaignGroupKind } from "utils/select_options/channel_campaign_group_kind_options";

const ChannelCampaignGroups = ({
  channel_id,
  channel_campaign_id,
  data,
  refetch,
}) => {
  const [channel_campaign_group_to_delete, setChannelCampaignGroupToDelete] =
    useState(null);

  const { is_deleting, _delete } = useDelete({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/${channel_campaign_group_to_delete?.id}`,
  });

  const handleDelete = async () => {
    await _delete();
    refetch();
    setChannelCampaignGroupToDelete(null);
  };

  return (
    <Dashboard
      header={{
        icon: "channel",
        title: "Grupy kampanii",
        aside: (
          <Button
            type="add"
            text="Dodaj grupę kampanii"
            path={`/campaigns/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/new`}
          />
        ),
      }}
    >
      {channel_campaign_group_to_delete?.id && (
        <ModalDelete
          name={`grupę kampanii ${channel_campaign_group_to_delete?.name}?`}
          handleDelete={handleDelete}
          handleClose={() => setChannelCampaignGroupToDelete(null)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, name, kind, status }) => (
              <tr key={id}>
                <td>
                  <Label
                    type="fill"
                    text={channel_campaign_statuses?.[status]?.name}
                    color={channel_campaign_statuses?.[status]?.color}
                  />
                  <strong className="m-r-10">
                    {getChannelCampaignGroupKind(kind)}
                  </strong>
                  <Link
                    className="text-link"
                    to={`/campaigns/channels/${channel_id}/channel_campaigns/${channel_campaign_id}/channel_campaign_groups/${id}`}
                  >
                    {name}
                  </Link>
                </td>
                <td>
                  {status !== "ARCHIVED" && (
                    <ExpanoButton
                      disabled={is_deleting}
                      type="delete-bin"
                      onClick={() =>
                        setChannelCampaignGroupToDelete({
                          id,
                          name,
                        })
                      }
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default ChannelCampaignGroups;
